<template>
    <div>
           <van-nav-bar
  title="美团"
  fixed
  left-arrow
  @click-left="$router.go(-1)"
/>
 <van-empty description="该功能正在开发中" />
    </div>
</template>

<script>
export default {  
    data(){
        return{

        }
    },
  created() {
    this.Post({}, "/mt", res => {
      if (res.states == 1) {
        console.log(res)
      }
    });
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/mt/index.vue